import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex flex-col">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20red%20velvet%20curtains%20partially%20opened%20revealing%20bright%20spotlight%2C%20mysterious%20atmosphere%2C%20theatrical%20lighting%20with%20warm%20golden%20spotlights%20cutting%20through%20darkness%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20high%20contrast%20chiaroscuro%20style%2C%20entertainment%20industry%20backstage%20vibe&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="黑料吃瓜网 - 全网独家爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 flex-1 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
            <div className="lg:w-[60%] pt-16 md:pt-20">
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black font-heading text-white leading-tight tracking-tight">
                <span className="block">全网独家</span>
                <span className="block text-primary-400">爆料猛料</span>
                <span className="block">一手大瓜立刻开吃</span>
              </h1>
            </div>
            <div className="lg:w-[40%] pt-0 lg:pt-28 pb-8">
              <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-md">
                黑料吃瓜网实时聚合51黑料、91黑料、网红塌房、明星丑闻等全网独家爆料。
                每日不打烊，最新吃瓜视频在线观看，网曝一区二区猛料不断。
              </p>
              <Link
                to="/category/mengliao"
                className="inline-flex items-center gap-2 px-8 py-3 text-base font-semibold rounded-full border-2 border-white/60 text-white hover:bg-white/10 hover:border-white transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                立即开吃
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full h-[45%] min-h-[260px] md:min-h-[320px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Collage%20of%20viral%20social%20media%20posts%20and%20news%20headlines%20on%20a%20dark%20background%2C%20glowing%20smartphone%20screens%20displaying%20trending%20topics%2C%20dramatic%20red%20accents%2C%20modern%20digital%20media%20art%20style%2C%20warm%20golden%20highlights%2C%20cinematic%20wide%20composition&width=1920&height=700&seq=hero-bottom-2026&orientation=landscape"
          alt="今日最热爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
      </div>
    </section>
  );
}